import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '../../api/axiosInstance'

const COLORS = {
  gray:   '#5B6B79',
  blue:   '#4680ff',
  green:  '#2CA87F',
}

const TABS = ['Transactions', 'Customers']

const LoyaltySystem = () => {
  const navigate = useNavigate()
  const [hovered, setHovered]     = useState(null)
  const [appLink, setAppLink]     = useState('')
  const [activeTab, setActiveTab] = useState('Transactions')
  const [customers, setCustomers]     = useState([])
  const [custLoading, setCustLoading] = useState(false)
  const [custError, setCustError]     = useState('')
  const [transactions, setTransactions]     = useState([])
  const [txnLoading, setTxnLoading]         = useState(false)
  const [txnError, setTxnError]             = useState('')

  useEffect(() => {
    axiosInstance.get('/loyalty/connection')
      .then(res => { if (res.data?.app_link) setAppLink(res.data.app_link) })
      .catch(() => {})
  }, [])

  useEffect(() => {
    if (activeTab !== 'Customers') return
    setCustLoading(true)
    setCustError('')
    axiosInstance.get('/loyalty/customers')
      .then(res => setCustomers(res.data?.data || []))
      .catch(err => setCustError(err?.response?.data?.message || 'Failed to load customers'))
      .finally(() => setCustLoading(false))
  }, [activeTab])

  useEffect(() => {
    if (activeTab !== 'Transactions') return
    setTxnLoading(true)
    setTxnError('')
    axiosInstance.get('/loyalty/transactions')
      .then(res => setTransactions(res.data?.data || []))
      .catch(err => setTxnError(err?.response?.data?.message || 'Failed to load transactions'))
      .finally(() => setTxnLoading(false))
  }, [activeTab])

  const CARDS = [
    {
      label: 'Link',
      icon:  'ti ti-link',
      color: COLORS.blue,
      onClick: () => navigate('/Admin/LoyaltySystem/Link'),
    },
    {
      label: 'Go To Loyalty System',
      icon:  'ti ti-award',
      color: COLORS.green,
      onClick: () => appLink ? window.open(appLink, '_blank', 'noopener,noreferrer') : navigate('/Admin/LoyaltySystem/Link'),
    },
  ]

  return (
    <div className="pc-container">
      <div className="pc-content">

        {/* ── Page Header ── */}
        <div style={{
          background: '#fff', borderRadius: 12, border: '1px solid #e8ecf0',
          padding: '16px 24px', marginBottom: 20,
          display: 'flex', alignItems: 'center', gap: 12,
        }}>
          <div style={{
            width: 38, height: 38, borderRadius: 10,
            background: `${COLORS.blue}15`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <i className="ti ti-award" style={{ color: COLORS.blue, fontSize: 20 }} />
          </div>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: '#1a202c' }}>Loyalty System</div>
            <div style={{ fontSize: 12, color: COLORS.gray }}>Manage patient loyalty programmes and rewards</div>
          </div>
        </div>

        {/* ── Cards Grid ── */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 16,
          flexWrap: 'wrap',
        }}>
          {CARDS.map((c, i) => {
            const isHov = hovered === i
            return (
              <button
                key={c.label}
                onClick={c.onClick}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
                style={{
                  background: '#fff',
                  border: `1.5px solid ${isHov ? c.color : '#e8ecf0'}`,
                  borderRadius: 12,
                  padding: '10px 24px',
                  textAlign: 'left',
                  cursor: 'pointer',
                  transition: 'border-color 0.18s, box-shadow 0.18s, transform 0.12s',
                  boxShadow: isHov ? `0 4px 18px ${c.color}22` : '0 1px 4px rgba(0,0,0,0.04)',
                  transform: isHov ? 'translateY(-2px)' : 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  width: 240,
                }}
              >
                <div style={{
                  width: 34, height: 34, borderRadius: 8, flexShrink: 0,
                  background: isHov ? c.color : `${c.color}15`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  transition: 'background 0.18s',
                }}>
                  <i className={c.icon} style={{
                    fontSize: 18,
                    color: isHov ? '#fff' : c.color,
                    transition: 'color 0.18s',
                  }} />
                </div>

                <div style={{
                  fontSize: 14, fontWeight: 700,
                  color: isHov ? c.color : '#1a202c',
                  transition: 'color 0.18s',
                  flex: 1,
                }}>
                  {c.label}
                </div>

                <i className="ti ti-chevron-right" style={{
                  fontSize: 16, color: isHov ? c.color : '#ccc',
                  flexShrink: 0, transition: 'color 0.18s',
                }} />
              </button>
            )
          })}
        </div>

        {/* ── Tabs ── */}
        <div style={{ marginTop: 32 }}>

          {/* Tab headers */}
          <div style={{
            display: 'flex', gap: 4,
            borderBottom: '2px solid #e8ecf0',
            marginBottom: 0,
          }}>
            {TABS.map(tab => {
              const active = activeTab === tab
              return (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  style={{
                    padding: '10px 24px',
                    fontSize: 13, fontWeight: 600,
                    border: 'none', background: 'none',
                    cursor: 'pointer',
                    color: active ? COLORS.blue : COLORS.gray,
                    borderBottom: `2px solid ${active ? COLORS.blue : 'transparent'}`,
                    marginBottom: -2,
                    transition: 'color 0.15s, border-color 0.15s',
                  }}
                >
                  {tab}
                </button>
              )
            })}
          </div>

          {/* Tab content */}
          <div style={{
            background: '#fff',
            border: '1px solid #e8ecf0',
            borderTop: 'none',
            borderRadius: '0 0 12px 12px',
            minHeight: 200,
          }}>
            {activeTab === 'Transactions' && (
              <>
                {txnLoading && (
                  <div style={{ padding: '40px 24px', textAlign: 'center', color: COLORS.gray, fontSize: 13 }}>
                    <i className="ti ti-loader-2" style={{ fontSize: 22, marginBottom: 8, display: 'block' }} />
                    Loading transactions…
                  </div>
                )}

                {!txnLoading && txnError && (
                  <div style={{ padding: '32px 24px', textAlign: 'center', color: '#dc3545', fontSize: 13 }}>
                    <i className="ti ti-alert-circle" style={{ fontSize: 22, marginBottom: 8, display: 'block' }} />
                    {txnError}
                  </div>
                )}

                {!txnLoading && !txnError && transactions.length === 0 && (
                  <div style={{ padding: '40px 24px', textAlign: 'center', color: COLORS.gray, fontSize: 13 }}>
                    <i className="ti ti-receipt" style={{ fontSize: 36, marginBottom: 10, display: 'block', opacity: 0.35 }} />
                    No transactions found
                  </div>
                )}

                {!txnLoading && !txnError && transactions.length > 0 && (
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                      <thead>
                        <tr style={{ borderBottom: '2px solid #e8ecf0', background: '#f8fafc' }}>
                          {['#', 'Date / Time', 'Invoice ID', 'Patient Name', 'Mobile', 'Amount', 'Status', 'Transaction ID'].map(h => (
                            <th key={h} style={{
                              padding: '11px 16px', textAlign: 'left',
                              fontWeight: 700, color: '#1a202c', fontSize: 12,
                              whiteSpace: 'nowrap',
                            }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {transactions.map((t, i) => {
                          const status = (t.payment_status || '').toLowerCase()
                          const statusColor = status === 'success' ? COLORS.green : status === 'failed' || status === 'cancelled' ? '#dc3545' : COLORS.orange
                          const statusBg   = status === 'success' ? '#d1fae5' : status === 'failed' || status === 'cancelled' ? '#fee2e2' : '#fff3cd'
                          return (
                            <tr key={t.payment_id} style={{
                              borderBottom: '1px solid #f1f3f5',
                              background: i % 2 === 0 ? '#fff' : '#fafbfc',
                            }}>
                              <td style={{ padding: '10px 16px', color: COLORS.gray }}>{i + 1}</td>
                              <td style={{ padding: '10px 16px', color: '#1a202c', whiteSpace: 'nowrap' }}>
                                {t.payment_date ? new Date(t.payment_date).toLocaleString() : '—'}
                              </td>
                              <td style={{ padding: '10px 16px', color: '#1a202c' }}>
                                {t.invoice_id ?? <span style={{ color: COLORS.gray, fontSize: 11 }}>Advance</span>}
                              </td>
                              <td style={{ padding: '10px 16px', fontWeight: 600, color: '#1a202c' }}>{t.patient_name || '—'}</td>
                              <td style={{ padding: '10px 16px', fontFamily: 'monospace', color: '#1a202c' }}>{t.mobile || '—'}</td>
                              <td style={{ padding: '10px 16px', fontWeight: 600, color: '#1a202c' }}>{t.payment_amount ?? '—'}</td>
                              <td style={{ padding: '10px 16px' }}>
                                <span style={{
                                  fontSize: 11, fontWeight: 700,
                                  background: statusBg, color: statusColor,
                                  padding: '3px 8px', borderRadius: 4,
                                  textTransform: 'capitalize',
                                }}>
                                  {t.payment_status || '—'}
                                </span>
                              </td>
                              <td style={{ padding: '10px 16px', fontFamily: 'monospace', color: COLORS.gray, fontSize: 12 }}>
                                {t.transaction_id || '—'}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}

            {activeTab === 'Customers' && (
              <>
                {custLoading && (
                  <div style={{ padding: '40px 24px', textAlign: 'center', color: COLORS.gray, fontSize: 13 }}>
                    <i className="ti ti-loader-2" style={{ fontSize: 22, marginBottom: 8, display: 'block' }} />
                    Loading customers…
                  </div>
                )}

                {!custLoading && custError && (
                  <div style={{ padding: '32px 24px', textAlign: 'center', color: '#dc3545', fontSize: 13 }}>
                    <i className="ti ti-alert-circle" style={{ fontSize: 22, marginBottom: 8, display: 'block' }} />
                    {custError}
                  </div>
                )}

                {!custLoading && !custError && customers.length === 0 && (
                  <div style={{ padding: '40px 24px', textAlign: 'center', color: COLORS.gray, fontSize: 13 }}>
                    <i className="ti ti-users" style={{ fontSize: 36, marginBottom: 10, display: 'block', opacity: 0.35 }} />
                    No customers found
                  </div>
                )}

                {!custLoading && !custError && customers.length > 0 && (
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                      <thead>
                        <tr style={{ borderBottom: '2px solid #e8ecf0', background: '#f8fafc' }}>
                          {['#', 'Customer Name', 'Age', 'Gender', 'Mobile', 'Card ID', 'Balance'].map(h => (
                            <th key={h} style={{
                              padding: '11px 16px', textAlign: 'left',
                              fontWeight: 700, color: '#1a202c', fontSize: 12,
                              whiteSpace: 'nowrap',
                            }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {customers.map((c, i) => (
                          <tr key={i} style={{
                            borderBottom: '1px solid #f1f3f5',
                            background: i % 2 === 0 ? '#fff' : '#fafbfc',
                          }}>
                            <td style={{ padding: '10px 16px', color: COLORS.gray }}>{i + 1}</td>
                            <td style={{ padding: '10px 16px', fontWeight: 600, color: c.matched ? '#1a202c' : COLORS.gray }}>
                              {c.name}
                              {!c.matched && (
                                <span style={{
                                  marginLeft: 8, fontSize: 10, fontWeight: 600,
                                  background: '#fff3cd', color: '#856404',
                                  padding: '2px 6px', borderRadius: 4,
                                }}>No match</span>
                              )}
                              {c.matched && c.sharedCard && (
                                <span style={{
                                  marginLeft: 8, fontSize: 10, fontWeight: 600,
                                  background: '#fff3cd', color: '#856404',
                                  padding: '2px 6px', borderRadius: 4,
                                }}>Shared card</span>
                              )}
                            </td>
                            <td style={{ padding: '10px 16px', color: '#1a202c' }}>{c.age}</td>
                            <td style={{ padding: '10px 16px', color: '#1a202c', textTransform: 'capitalize' }}>{c.gender}</td>
                            <td style={{ padding: '10px 16px', color: '#1a202c', fontFamily: 'monospace' }}>{c.mobile}</td>
                            <td style={{ padding: '10px 16px', color: '#1a202c', fontFamily: 'monospace' }}>{c.card_id}</td>
                            <td style={{ padding: '10px 16px', fontWeight: 600, color: COLORS.green }}>{c.points}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}
          </div>

        </div>

      </div>
    </div>
  )
}

export default LoyaltySystem
